import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { InboundDeliveryResponse } from './common/inboundDeliveryResponse';

export interface AddInboundDeliveryTransactionRequest {
  deliveryId: string;
  deliveryRowId: string;
  productId: string;
  storageAreaId: string | null;
  weight: number | null;
  volume: number | null;
  comment: string | null;
}

export interface AddInboundDeliveryTransactionResponse {
  ok: true;
  delivery: InboundDeliveryResponse;
}

export function useAddInboundDeliveryTransactionApi() {
  return useCreateEntityApi<
    AddInboundDeliveryTransactionRequest,
    AddInboundDeliveryTransactionResponse
  >({
    url: 'delivery/inbound/transaction',
    translate: (t) => t.inboundDelivery.actions.transaction,
    async processOk(response) {
      const json = (await response.json()) as InboundDeliveryResponse;
      return {
        ok: true,
        delivery: json,
      };
    },
  });
}
